export const GET_SYSTEM_BACKUP = 'GET_SYSTEM_BACKUP';
export const GET_SYSTEM_BACKUP_SUCCESS = 'GET_SYSTEM_BACKUP_SUCCESS';
export const GET_SYSTEM_BACKUP_FAIL = 'GET_SYSTEM_BACKUP_FAIL';

export const ADD_SYSTEM_BACKUP = 'ADD_SYSTEM_BACKUP';
export const ADD_SYSTEM_BACKUP_COMPLETE = 'ADD_SYSTEM_BACKUP_COMPLETE';

export const UPLOAD_SYSTEM_BACKUP = "UPLOAD_SYSTEM_BACKUP";
export const UPLOAD_SYSTEM_BACKUP_COMPLETE = "UPLOAD_SYSTEM_BACKUP_COMPLETE";

export const DELETE_SYSTEM_BACKUP = 'DELETE_SYSTEM_BACKUP';
export const DELETE_SYSTEM_BACKUP_SUCCESS = 'DELETE_SYSTEM_BACKUP_SUCCESS';
export const DELETE_SYSTEM_BACKUP_FAIL = 'DELETE_SYSTEM_BACKUP_FAIL';

export const DOWNLOAD_SYSTEM_BACKUP = 'DOWNLOAD_SYSTEM_BACKUP';
export const DOWNLOAD_SYSTEM_BACKUP_SUCCESS = 'DOWNLOAD_SYSTEM_BACKUP_SUCCESS';
export const DOWNLOAD_SYSTEM_BACKUP_FAIL = 'DOWNLOAD_SYSTEM_BACKUP_FAIL';

export const RESTORE_SYSTEM_BACKUP = 'RESTORE_SYSTEM_BACKUP';
export const RESTORE_SYSTEM_BACKUP_SUCCESS = 'RESTORE_SYSTEM_BACKUP_SUCCESS';
export const RESTORE_SYSTEM_BACKUP_FAIL = 'RESTORE_SYSTEM_BACKUP_FAIL';